<!--
 * @Author: Merlin
 * @Date: 2024-06-04 11:17:54
 * @LastEditors: Merlin
 * @LastEditTime: 2024-12-26 11:50:01
 * @Description: 
-->
<template>
    <div
        class="flex bg-[#1C2532FF] py-[10px] rounded-lg relative cursor-pointer hover:bg-[#2A3546FF]"
    >
        <div class="flex-1 font-semibold flex gap-2 sm:block items-center line">
            <div class="text-base text-[#b5c2cf] inline-flex gap-1">
                <CurrentCoin />
                {{ settinsStore.pickedCurrency.toUpperCase() }}
            </div>
            <div class="inline-flex w-full">
                {{ oLimitValues.min }}
            </div>
        </div>
        <!-- 左右|分界 -->
        <div class="flex-1 font-semibold relative flex gap-2 sm:block items-center pl-5">
            <div class="text-base text-[#b5c2cf] inline-flex gap-1">
                <CurrentCoin />
                {{ settinsStore.pickedCurrency.toUpperCase() }}
            </div>
            <div class="inline-flex w-full">
                {{ oLimitValues.max }}
            </div>
            <q-icon
                name="arrow_drop_down"
                class="text-white flex-[1] absolute m-auto top-[50%] right-0"
            />
        </div>
    </div>
</template>

<script lang="ts" setup>
import betHelper from '~/common/js/betHelper';
import { useJoinStateStore } from '~/stores/cansino/joinState';
import useSettingsStore from '~/stores/settings';

const settinsStore = useSettingsStore();
const joinStateStore = useJoinStateStore();

// defineProps({ });

// ↓ 当前币种的下注金额上限下限 
const oLimitValues = computed(()=>{
    let [min, max] = [0, 0];
    if (joinStateStore.gameOfRoute === 'circleGame'){
        const arr = Object.values(
            joinStateStore.config[settinsStore.pickedCurrency]?.sectors
        );
        const aMinArr = arr.map(cur=>cur['minBetAmount']);
        const aMaxArr = arr.map(cur=>cur['maxBetAmount']);
        min = Math.min(...aMinArr);
        max = Math.max(...aMaxArr);
    }else{
        min = betHelper.getMinBetAmout();
        max = betHelper.getMaxBetAmout();
    }
    const oResult = {
        min: number2LocaleString(min),
        max: number2LocaleString(max),
    }
    return oResult;
});

</script>

<style lang="scss" scoped>
/* ↑ 后补 scoped 于 2024.05.02 17:37:56 星期四  */

.line::before {
    content: '';
    background: #3c485c;
    bottom: 17px;
    left: 49%;
    position: absolute;
    top: 17px;
    transform: translate(-50%);
    width: 1px;
}
</style>
